import React, { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Layout from "../Common/Layout";
import { Toast } from "primereact/toast";
import axios from "axios";

export default function History() {
  const [quotes, setQuotes] = useState<any>([]);
  const [searchText, setSearchText] = useState("");
  const [showAllAgents, setShowAllAgents] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const toast = React.useRef<Toast>(null);

  useEffect(() => {
    // Load saved quotes from localStorage
    // const saved = localStorage.getItem("savedQuotes");
    // if (saved) {
    //   setQuotes(JSON.parse(saved));
    // }
    // getAllQuotes();
  }, []);

  useEffect(() => {
    if (showAllAgents) {
      getAllAgentsQuotes();
    } else {
      getAllQuotes();
    }
  }, [showAllAgents]);

  const getAllQuotes = () => {
    setLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/getquotehistory`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
    })
      .then((response: any) => {
        setQuotes(response.data);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Unknown error while getting history!",
            life: 3000,
          });
        }
      });
  };
   const getAllAgentsQuotes = () => {
    setLoading(true);
    axios({
      method: "get",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/agentsquotehistory`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "Application/json",
      },
    })
      .then((response: any) => {
        setQuotes(response.data);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.response?.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Unknown error while getting history!",
            life: 3000,
          });
        }
      });
  };
  const handleEdit = (rowData: any) => {
    localStorage.setItem("currentInsuredId", rowData.insuredId);
    localStorage.removeItem("ancillaryFlow");
    navigate(`/insurance-workflow?transactionId=${rowData.transactionId}`, {
      state: {
        stepIndex: parseInt(rowData.currentStep || "0", 10),
        quoteType: rowData.quoteType,
      }
    });
  };

  // Filter quotes by search text
  const filteredQuotes = quotes.filter((q: any) => {
    const text = searchText.toLowerCase();
    return (
      (q.clientName && q.clientName.toLowerCase().includes(text)) ||
      (q.email && q.email.toLowerCase().includes(text)) ||
      (q.phone && q.phone.toLowerCase().includes(text)) ||
      (q.address && q.address.toLowerCase().includes(text))
    );
  });

  const actionBodyTemplate = (rowData: any) => (
    <button className="btn btn-secondary" title="Edit" onClick={() => handleEdit(rowData)}>
      Edit
    </button>
  );

  // Extract state from contactInformationJson
  const getState = (rowData: any): string => {
    if (rowData.state) return rowData.state;
    try {
      const raw = rowData.contactInformationJson;
      if (!raw) return "";
      // Handle double-serialized JSON (value may be wrapped in extra quotes)
      const jsonStr = raw.startsWith('"') ? JSON.parse(raw) : raw;
      const parsed = typeof jsonStr === "string" ? JSON.parse(jsonStr) : jsonStr;
      return parsed?.state || "";
    } catch {
      return "";
    }
  };

  // Format date as MM/DD/YYYY HH:MM
  const formatDate = (dateStr: string) => {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const pad = (n: number) => n.toString().padStart(2, "0");
    return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  return (
    <Layout currentPage="History">
      <Toast ref={toast} />

      <div className="page-container ">
        <div className="page-header">
          <div className="page-header-content">
            <div className="page-title-section">
              <h1>History</h1>
              <span className="title-separator">|</span>
              <p>View and manage your saved quotes</p>
            </div>
          </div>
        </div>
        {/* Search and filter section */}
        {loading && (
          <div className="driver-loading-overlay">
            <div className="driver-loading-content">
              <div className="driver-loading-spinner" />
              <p className="driver-loading-text">Loading quote history...</p>
            </div>
          </div>
        )}
        <div className="mx-3 mt-4">
          <div className="" style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 24 }}>
            <span style={{ fontWeight: 500 }}>Search:</span>
            <InputText
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Search quotes..."
              style={{ width: "auto" }}
              className="form-input"
            />
            <input
              type="checkbox"
              checked={showAllAgents}
              onChange={(e) => setShowAllAgents((e.target as HTMLInputElement).checked)}
              style={{ marginLeft: 24 }}
              className="ancillary-checkbox"
            />

            <label htmlFor="showAllAgents" style={{ marginLeft: 8, fontWeight: 500 }}>
              Show quotes from all agents
            </label>
          </div>
          <DataTable
            value={filteredQuotes}
            className="custom-datatable history-table"
            showGridlines
            responsiveLayout="scroll"
            emptyMessage="No saved quotes found."
            style={{ width: "100%" }}
            sortMode="multiple"
            paginator
            rows={10}
          >
            <Column field="clientName" header="Client Name" sortable />
            {showAllAgents && <Column field="agentName" header="Agent Name" sortable />}
            <Column field="email" header="Email" sortable />
            <Column field="phone" header="Phone" sortable />
            <Column field="address" header="Address" sortable />
            <Column header="State" body={(rowData) => getState(rowData)} sortable />
            <Column field="created" header="Date" body={(rowData) => formatDate(rowData.created)} sortable />
            <Column
              field="status"
              header="Status"
              body={(rowData) => (
                <span className={`history-status-badge ${rowData.status === "Completed" ? "completed" : "inprogress"}`}>{rowData.status}</span>
              )}
              sortable
            />
            <Column body={actionBodyTemplate} header="Action" style={{ textAlign: "center", width: "80px" }} />
          </DataTable>
        </div>
      </div>
    </Layout>
  );
}
